import { render, staticRenderFns } from "./OAuthPopupResult.vue?vue&type=template&id=7c5a4ada&scoped=true&lang=pug&"
import script from "./OAuthPopupResult.vue?vue&type=script&lang=js&"
export * from "./OAuthPopupResult.vue?vue&type=script&lang=js&"
import style0 from "./OAuthPopupResult.vue?vue&type=style&index=0&id=7c5a4ada&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a4ada",
  null
  
)

/* custom blocks */
import block0 from "./OAuthPopupResult.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports